/**
 * RainbowKit configuration for wallet modal
 * Configured for maximum compatibility with mobile wallets and web3 browsers
 * Uses getDefaultConfig for proper mobile WalletConnect v2 support
 */

import { getDefaultConfig } from '@rainbow-me/rainbowkit'
import { lightTheme } from '@rainbow-me/rainbowkit'
import { http, fallback } from 'wagmi'
import { mainnet } from 'wagmi/chains'

// ⚠️ WARNING: Replace with production Project ID before deployment!
// Current ID (0f3138b38032028dbe92c8adb0ca80e4) is for development only
// Get production ID at: https://cloud.walletconnect.com
const projectId = import.meta.env.VITE_WALLET_CONNECT_PROJECT_ID || '0f3138b38032028dbe92c8adb0ca80e4'

// App metadata for WalletConnect v2 (required for proper mobile wallet support)
const appName = 'Bitcoin.com Loans & Mortgages'

// ⚠️ IMPORTANT: This application ONLY works on Ethereum Mainnet
// The Anvil Protocol smart contracts are deployed exclusively on Ethereum Mainnet
// Do not add other chains to this configuration

// Multiple public RPC endpoints with fallback support
// Ordered by latency (fastest first) based on public RPC benchmarks
const mainnetTransport = fallback([
  http('https://eth.rpc.blxrbdn.com'),                    // 0.141s - Fastest
  http('https://mainnet.gateway.tenderly.co'),            // 0.155s
  http('https://ethereum-public.nodies.app'),             // 0.161s
  http('https://gateway.tenderly.co/public/mainnet'),     // 0.168s
  http('https://ethereum-rpc.publicnode.com'),            // 0.175s
  http('https://eth-mainnet.public.blastapi.io'),         // 0.189s
  http('https://eth.drpc.org'),                           // 0.209s
  http('https://rpc.flashbots.net'),                      // 0.244s
  http('https://eth.llamarpc.com'),                       // 0.471s - Fallback
])

// Use getDefaultConfig for proper RainbowKit wallet discovery and mobile support
// This includes built-in WalletConnect v2 configuration with proper mobile handling
export const rainbowKitConfig = getDefaultConfig({
  appName,
  projectId,
  chains: [mainnet],
  transports: {
    [mainnet.id]: mainnetTransport,
  },
  ssr: false,
})

// App info for RainbowKitProvider
export const appInfo = {
  appName,
  learnMoreUrl: 'https://docs.anvilapplication.com',
}

// Custom theme configuration using RainbowKit's lightTheme
export const rainbowKitTheme = lightTheme({
  accentColor: '#FF6B35', // Bitcoin.com brand orange
  accentColorForeground: 'white',
  borderRadius: 'medium',
  fontStack: 'system',
  overlayBlur: 'small',
})

